import Store from 'utils/store';

window.nav = Store.store('nav', function () {
  let data = {
    showMobileNav: false,
  };

  return data;
});
